// import MainView from "views/MainView";
// import { SupportedLocales } from "views/IntlContext";
// import { useLocation } from "react-router-dom";
// import { useEffect, useState, useRef } from "react";
// import {
//   supportAlexaProduct,
//   supportGoogleProduct,
//   _H5Event,
//   handleFromAppParams,
//   // ThirdPartyService,
//   detectMobileOS,
//   alexaUnlink,
//   publicPath,
//   supportHealthProduct,
//   IAuth,
//   // ServicePlatformType,
//   INTEGRATED_SERVICE,
//   IThirdPartyService,
//   PLATFORM_CONFIGS,
// } from "request";
// import { FormattedMessage } from "react-intl";
// import { useIntlContext } from "views/IntlContext";
// import { clsx } from "clsx";

// import { ProductRow } from "./components";
// import { Empty, Spinner } from "components";

// import { Skeleton } from "antd-mobile";

// type ServiceConnectProps = {
//   connectService: IThirdPartyService;
//   lang: SupportedLocales;
// };

// const ServiceConnect = () => {
//   const { switchLanguage } = useIntlContext();

//   const [connectService, setConnectService] = useState<
//     IThirdPartyService | undefined
//   >(undefined);

//   const [productList, setProductList] = useState<any[]>([]);
//   const [isAuthorized, setIsAuthorized] = useState<boolean>(false);
//   const [isLoading, setIsLoading] = useState<boolean>(true);
//   const [isAuthLoading, setIsAuthLoading] = useState<boolean>(false);

//   const queryObject = useRef<IAuth>({
//     lang: SupportedLocales.English,
//     token: "",
//   });

//   const location = useLocation();
//   const { state } = location as { state: ServiceConnectProps };

//   useEffect(() => {
//     const authSuccessHandler = () => setIsAuthorized(true);
//     (window as any).authSuccessToReload = authSuccessHandler;
//     return () => {
//       delete (window as any).authSuccessToReload;
//     };
//   }, []);

//   useEffect(() => {
//     const authResultReceived = (result: boolean) => {
//       setIsAuthorized(result);
//       setIsAuthLoading(false);
//     };
//     (window as any).authResultReceived = authResultReceived;
//     return () => {
//       delete (window as any).authResultReceived;
//     };
//   }, []);

//   useEffect(() => {
//     if (state) {
//       setConnectService(state.connectService);
//       switchLanguage?.(state.lang);
//     }
//   }, [state]);

//   const fetchProductList = (data: IAuth) => {
//     let promise: Promise<any>;
//     switch (connectService?.showFlag) {
//       case INTEGRATED_SERVICE.alexa:
//         promise = supportAlexaProduct({
//           ...data,
//           data: { id: connectService?.id },
//         });
//         break;
//       case INTEGRATED_SERVICE.googleAssistant:
//         promise = supportGoogleProduct({
//           ...data,
//           data: { id: connectService?.id },
//         });
//         break;
//       case INTEGRATED_SERVICE.appleHealth:
//       case INTEGRATED_SERVICE.googleFit:
//       case INTEGRATED_SERVICE.healthConnect:
//         promise = supportHealthProduct({
//           ...data,
//           data: { id: connectService?.id },
//         });
//         break;
//       default:
//         console.warn(`Unknown serviceName: ${connectService?.showFlag}`);
//         return;
//     }

//     promise
//       .then((response: any) => {
//         setIsLoading(false);
//         if (response?.code === "200") {
//           setProductList(response.result.hasProductList || []);
//           if (connectService?.showFlag === INTEGRATED_SERVICE.googleAssistant) {
//             setIsAuthorized(response.result.authFlag);
//           }
//         }
//       })
//       .catch((err: any) => {
//         setIsLoading(false);
//         console.error(
//           `Error fetching product list for ${connectService?.showFlag}:`,
//           err.message
//         );
//       });
//   };

//   const onAuth = () => {
//     switch (connectService?.showFlag) {
//       case INTEGRATED_SERVICE.googleAssistant:
//         onGoogleAssistantAuth();
//         break;
//       case INTEGRATED_SERVICE.alexa:
//         onAlexaAuth();
//         break;
//       case INTEGRATED_SERVICE.appleHealth:
//       case INTEGRATED_SERVICE.googleFit:
//       case INTEGRATED_SERVICE.healthConnect:
//         onHealthServiceAuth();
//         break;
//       default:
//         console.warn("Unknown service:", connectService?.showFlag);
//     }
//   };

//   const onUnlink = () => {
//     switch (connectService?.showFlag) {
//       case INTEGRATED_SERVICE.alexa:
//         onAlexaUnlink();
//         break;
//       default:
//         console.warn(
//           "Unlink action not supported for:",
//           connectService?.showFlag
//         );
//     }
//   };

//   const onConnect = () => {
//     if (isAuthLoading) return;

//     if (!isAuthorized) {
//       onAuth();
//     } else {
//       onUnlink();
//     }
//   };

//   const onGoogleAssistantAuth = () => {
//     const { isAndroid } = detectMobileOS();
//     const androidPackName = "com.google.android.apps.chromecast.app";
//     const googleHomeUrl =
//       "https://play.google.com/store/apps/details?id=com.google.android.apps.chromecast.app&hl=en_US&gl=US";
//     const iosVideoUrl = "https://apps.apple.com/us/app/google-home/id680819774";

//     if (isAndroid) {
//       window.android?.gotoyoutobe(androidPackName, "", googleHomeUrl);
//     } else {
//       _H5Event({
//         event: "OpenThirdAppOrBrower",
//         type: "app",
//         url: "googlehome://",
//         videoUrl: iosVideoUrl,
//         pageName: "index",
//         callback: () => {},
//       });
//     }
//   };

//   const onHealthServiceAuth = () => {
//     // const toPageName = getPageName(serviceName as ThirdPartyService);
//     const serviceName = connectService?.showFlag;
//     if (!serviceName) {
//       console.warn("Service name is undefined");
//       return;
//     }
//     _H5Event({
//       event: "AppAuthorizationLogin",
//       pageName: "connect",
//       appName: PLATFORM_CONFIGS[serviceName]?.alias || "Unknown Service",
//       callback: () => {},
//     });
//   };

//   const onAlexaAuth = () => {
//     const serviceName = connectService?.showFlag;
//     if (!serviceName) {
//       console.warn("Service name is undefined");
//       return;
//     }

//     _H5Event({
//       event: "GoToConnectAlexaApp",
//       pageName: "connect",
//       appName: PLATFORM_CONFIGS[serviceName]?.alias || "Unknown Service",
//       callback: () => {},
//     });
//   };

//   const onAlexaUnlink = async () => {
//     setIsAuthLoading(true);
//     try {
//       const result: any = await alexaUnlink({
//         token: queryObject.current.token,
//         lang: queryObject.current.lang,
//       });
//       if (result?.code === "200") {
//         setIsAuthorized(false);
//       }
//     } catch (error) {
//       console.error("Error unlinking Alexa:", error);
//     } finally {
//       setIsAuthLoading(false);
//     }
//   };

//   useEffect(() => {
//     setIsLoading(true);
//     if (connectService?.showFlag) {
//       // const toPageName = getPageName(serviceName);

//       _H5Event({
//         event: "ShowInfoIcon",
//         pageName: "connect",
//         toPage: PLATFORM_CONFIGS[connectService?.showFlag]?.alias,
//         callback: (responseStr: any) => {
//           const jsonData = handleFromAppParams(responseStr);
//           if (
//             connectService?.showFlag === INTEGRATED_SERVICE.googleAssistant ||
//             connectService?.showFlag === INTEGRATED_SERVICE.googleFit ||
//             connectService?.showFlag === INTEGRATED_SERVICE.healthConnect
//           ) {
//             setIsAuthorized(jsonData.isAuthorized);
//           }
//           queryObject.current = jsonData;
//           fetchProductList(jsonData);
//         },
//       });
//     }
//   }, [connectService]);

//   useEffect(() => {
//     return () => {
//       _H5Event({
//         event: "HideInfoIcon",
//         pageName: "connect",
//         callback: () => {},
//       });
//     };
//   }, []);

//   const SkeletonItem = () => {
//     const logoStyle = {
//       "--width": "54px",
//       "--height": "54px",
//       "--border-radius": "8px",
//     };

//     const titleStyle = {
//       "--width": "50%",
//       "--border-radius": "2px",
//     };

//     return (
//       <div className="bg-white dark:bg-gray323434 rounded px-4 py-4 flex flex-row items-center mt-3">
//         <div>
//           <Skeleton animated style={logoStyle} />
//         </div>
//         <div className="w-full flex flex-col gap-4 px-3 flex-1">
//           <div className="flex flex-col gap-1">
//             <Skeleton
//               animated
//               style={{ ...titleStyle, "--height": "24px", "--width": "30%" }}
//             />
//             <Skeleton animated style={{ ...titleStyle, "--height": "16px" }} />
//           </div>
//           <div className="flex flex-col gap-1">
//             <Skeleton
//               animated
//               style={{ ...titleStyle, "--height": "18px", "--width": "70%" }}
//             />
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderServiceTitle = () => {
//     if (isAuthorized) {
//       return <FormattedMessage id="thirdParty.connect.success" />;
//     }

//     switch (connectService?.showFlag) {
//       case INTEGRATED_SERVICE.alexa:
//         return <FormattedMessage id="thirdParty.connect.alexa.title" />;
//       case INTEGRATED_SERVICE.googleAssistant:
//         return (
//           <FormattedMessage id="thirdParty.connect.google.assistant.title" />
//         );
//       case INTEGRATED_SERVICE.appleHealth:
//         return <FormattedMessage id="thirdParty.connect.apple.health.title" />;
//       case INTEGRATED_SERVICE.googleFit:
//         return <FormattedMessage id="thirdParty.connect.google.fit.title" />;
//       case INTEGRATED_SERVICE.healthConnect:
//         return (
//           <FormattedMessage id="thirdParty.connect.health.connect.title" />
//         );
//       default:
//         return null;
//     }
//   };

//   const renderServiceTip = () => {
//     return connectService?.showFlag === INTEGRATED_SERVICE.alexa ? (
//       <p className="px-4 pt-3 text-xs text-gray999">
//         <FormattedMessage id="thirdParty.connect.alexa.tip" />
//       </p>
//     ) : null;
//   };

//   const renderProductTitle = () => {
//     if (connectService?.showFlag === INTEGRATED_SERVICE.googleAssistant) {
//       return <FormattedMessage id="thirdParty.connect.product.title" />;
//     }

//     if (
//       connectService?.showFlag === INTEGRATED_SERVICE.appleHealth ||
//       connectService?.showFlag === INTEGRATED_SERVICE.googleFit ||
//       connectService?.showFlag === INTEGRATED_SERVICE.healthConnect
//     ) {
//       return (
//         <FormattedMessage id="thirdParty.connect.product.supportedProducts" />
//       );
//     }

//     return null;
//   };

//   const renderConnectButton = () => {
//     if (connectService?.showFlag === INTEGRATED_SERVICE.googleFit) {
//       return (
//         <div
//           className="w-fit px-4 bg-white flex items-center justify-center mx-auto p-2 rounded-[10px] font-bold shadow-[0_2px_2px_#ccc] active:bg-[#4285f4] active:text-white visited:bg-white visited:text-black visited:opacity-[0.54]"
//           onClick={onConnect}
//         >
//           <img
//             src={`${publicPath}/icons/g-logo.png`}
//             alt="Google"
//             className="w-[27px] h-[27px] mr-[10px]"
//           />
//           <span className="opacity-[0.54] text-lg">
//             <FormattedMessage id="thirdParty.connect.button.googleSignIn" />
//           </span>
//         </div>
//       );
//     }

//     return (
//       <button
//         type="button"
//         onClick={onConnect}
//         className={clsx(
//           "w-full flex items-center justify-center text-[#F7F7F9] rounded-lg h-[54px] text-lg",
//           {
//             "bg-primary opacity-70": isAuthLoading,
//             "bg-error": !isAuthLoading && isAuthorized,
//             "bg-primary": !isAuthLoading && !isAuthorized,
//           }
//         )}
//       >
//         {isAuthLoading ? (
//           <Spinner extraSmall className="border-white" />
//         ) : (
//           <FormattedMessage
//             id={`thirdParty.connect.button.${
//               isAuthorized ? "unlink" : "content"
//             }`}
//           />
//         )}
//       </button>
//     );
//   };

//   return (
//     <MainView backgroundClassName="bg-page dark:bg-black1b1f1e p-3">
//       <div className={clsx("bg-white dark:bg-gray323434 rounded py-7")}>
//         <div className="flex flex-row items-center justify-center gap-12">
//           <img
//             src={`${publicPath}/icons/ic_logo.png`}
//             className="w-[54px]"
//             alt="Logo"
//           />
//           <img
//             src={`${publicPath}/icons/ic_link.png`}
//             className="w-5"
//             alt="Link"
//           />
//           {connectService?.image && (
//             <img
//               src={connectService?.image}
//               className="w-[54px]"
//               alt={connectService?.name}
//             />
//           )}
//         </div>
//         <p className="px-8 mt-6 text-center max-w-[340px] md:max-w-full w-full mx-auto">
//           {renderServiceTitle()}
//         </p>
//       </div>
//       {renderServiceTip()}
//       <p className="mt-6">{renderProductTitle()}</p>
//       {isLoading ? (
//         <>
//           <SkeletonItem />
//           <SkeletonItem />
//         </>
//       ) : (
//         <>
//           {(!productList || productList.length === 0) && (
//             <Empty
//               emptyText={<FormattedMessage id="thirdParty.data.empty.text" />}
//             />
//           )}
//           <div className="overflow-y-auto pb-[88px]">
//             {productList &&
//               productList.length > 0 &&
//               productList.map((product, key) => (
//                 <ProductRow
//                   product={product}
//                   key={key}
//                   isVoiceProduct={
//                     connectService?.showFlag ===
//                     INTEGRATED_SERVICE.googleAssistant
//                   }
//                 />
//               ))}
//           </div>

//           <div className="fixed bottom-0 left-0 w-full py-4 p-4 bg-page dark:bg-gray323434">
//             {renderConnectButton()}
//           </div>
//         </>
//       )}
//     </MainView>
//   );
// };

// export { ServiceConnect };

// pages/thirdParty/ServiceConnect.tsx
import MainView from "views/MainView";
import { SupportedLocales } from "views/IntlContext";
import { useLocation } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import {
  supportAlexaProduct,
  supportGoogleProduct,
  _H5Event,
  handleFromAppParams,
  detectMobileOS,
  alexaUnlink,
  publicPath,
  supportHealthProduct,
  IAuth,
  INTEGRATED_SERVICE,
  IThirdPartyService,
  PLATFORM_CONFIGS,
} from "request";
// import { FormattedMessage } from "react-intl";
import { useIntlContext } from "views/IntlContext";
// import { clsx } from "clsx";

// import { ProductRow } from "./components";
// import { Empty, Spinner } from "components";

import { HeaderCard, ProductList, BottomButton } from "./components";

type ServiceConnectProps = {
  connectService: IThirdPartyService;
  lang: SupportedLocales;
};

const ServiceConnect = () => {
  const { switchLanguage } = useIntlContext();

  const [connectService, setConnectService] = useState<
    IThirdPartyService | undefined
  >(undefined);

  const [productList, setProductList] = useState<any[]>([]);
  const [isAuthorized, setIsAuthorized] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isAuthLoading, setIsAuthLoading] = useState<boolean>(false);

  const queryObject = useRef<IAuth>({
    lang: SupportedLocales.English,
    token: "",
  });

  const location = useLocation();
  const { state } = location as { state: ServiceConnectProps };

  useEffect(() => {
    const authSuccessHandler = () => setIsAuthorized(true);
    (window as any).authSuccessToReload = authSuccessHandler;
    return () => {
      delete (window as any).authSuccessToReload;
    };
  }, []);

  useEffect(() => {
    const authResultReceived = (result: boolean) => {
      setIsAuthorized(result);
      setIsAuthLoading(false);
    };
    (window as any).authResultReceived = authResultReceived;
    return () => {
      delete (window as any).authResultReceived;
    };
  }, []);

  useEffect(() => {
    if (state) {
      setConnectService(state.connectService);
      switchLanguage?.(state.lang);
    }
  }, [state]);

  const fetchProductList = (data: IAuth) => {
    let promise: Promise<any>;
    switch (connectService?.showFlag) {
      case INTEGRATED_SERVICE.alexa:
        promise = supportAlexaProduct({
          ...data,
          data: { id: connectService?.id },
        });
        break;
      case INTEGRATED_SERVICE.googleAssistant:
        promise = supportGoogleProduct({
          ...data,
          data: { id: connectService?.id },
        });
        break;
      case INTEGRATED_SERVICE.appleHealth:
      case INTEGRATED_SERVICE.googleFit:
      case INTEGRATED_SERVICE.healthConnect:
        promise = supportHealthProduct({
          ...data,
          data: { id: connectService?.id },
        });
        break;
      default:
        console.warn(`Unknown serviceName: ${connectService?.showFlag}`);
        return;
    }

    promise
      .then((response: any) => {
        setIsLoading(false);
        if (response?.code === "200") {
          setProductList(response.result.hasProductList || []);
          if (connectService?.showFlag === INTEGRATED_SERVICE.googleAssistant) {
            setIsAuthorized(response.result.authFlag);
          }
        }
      })
      .catch((err: any) => {
        setIsLoading(false);
        console.error(
          `Error fetching product list for ${connectService?.showFlag}:`,
          err.message
        );
      });
  };

  const onAuth = () => {
    switch (connectService?.showFlag) {
      case INTEGRATED_SERVICE.googleAssistant:
        onGoogleAssistantAuth();
        break;
      case INTEGRATED_SERVICE.alexa:
        onAlexaAuth();
        break;
      case INTEGRATED_SERVICE.appleHealth:
      case INTEGRATED_SERVICE.googleFit:
      case INTEGRATED_SERVICE.healthConnect:
        onHealthServiceAuth();
        break;
      default:
        console.warn("Unknown service:", connectService?.showFlag);
    }
  };

  const onUnlink = () => {
    switch (connectService?.showFlag) {
      case INTEGRATED_SERVICE.alexa:
        onAlexaUnlink();
        break;
      case INTEGRATED_SERVICE.googleAssistant:
        onGoogleAssistantAuth();
        break;
      case INTEGRATED_SERVICE.appleHealth:
      case INTEGRATED_SERVICE.googleFit:
      case INTEGRATED_SERVICE.healthConnect:
        onHealthServiceAuth();
        break;
      default:
        console.warn(
          "Unlink action not supported for:",
          connectService?.showFlag
        );
    }
  };

  const onConnect = () => {
    if (isAuthLoading) return;

    if (!isAuthorized) {
      onAuth();
    } else {
      onUnlink();
    }
  };

  const onGoogleAssistantAuth = () => {
    const { isAndroid } = detectMobileOS();
    const androidPackName = "com.google.android.apps.chromecast.app";
    const googleHomeUrl =
      "https://play.google.com/store/apps/details?id=com.google.android.apps.chromecast.app&hl=en_US&gl=US";
    const iosVideoUrl = "https://apps.apple.com/us/app/google-home/id680819774";

    if (isAndroid) {
      window.android?.gotoyoutobe(androidPackName, "", googleHomeUrl);
    } else {
      _H5Event({
        event: "OpenThirdAppOrBrower",
        type: "app",
        url: "googlehome://",
        videoUrl: iosVideoUrl,
        pageName: "index",
        callback: () => {},
      });
    }
  };

  const onHealthServiceAuth = () => {
    const serviceName = connectService?.showFlag;
    if (!serviceName) {
      console.warn("Service name is undefined");
      return;
    }
    _H5Event({
      event: "AppAuthorizationLogin",
      pageName: "connect",
      appName: PLATFORM_CONFIGS[serviceName]?.alias || "Unknown Service",
      callback: () => {},
    });
  };

  const onAlexaAuth = () => {
    const serviceName = connectService?.showFlag;
    if (!serviceName) {
      console.warn("Service name is undefined");
      return;
    }

    _H5Event({
      event: "GoToConnectAlexaApp",
      pageName: "connect",
      appName: PLATFORM_CONFIGS[serviceName]?.alias || "Unknown Service",
      callback: () => {},
    });
  };

  const onAlexaUnlink = async () => {
    setIsAuthLoading(true);
    try {
      const result: any = await alexaUnlink({
        token: queryObject.current.token,
        lang: queryObject.current.lang,
      });
      if (result?.code === "200") {
        setIsAuthorized(false);
      }
    } catch (error) {
      console.error("Error unlinking Alexa:", error);
    } finally {
      setIsAuthLoading(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    if (connectService?.showFlag) {
      _H5Event({
        event: "ShowInfoIcon",
        pageName: "connect",
        toPage: PLATFORM_CONFIGS[connectService?.showFlag]?.alias,
        callback: (responseStr: any) => {
          const jsonData = handleFromAppParams(responseStr);
          if (
            connectService?.showFlag === INTEGRATED_SERVICE.appleHealth ||
            connectService?.showFlag === INTEGRATED_SERVICE.googleFit ||
            connectService?.showFlag === INTEGRATED_SERVICE.healthConnect
          ) {
            setIsAuthorized(jsonData.isAuthorized);
          }
          queryObject.current = jsonData;
          fetchProductList(jsonData);
        },
      });
    }
  }, [connectService]);

  useEffect(() => {
    return () => {
      _H5Event({
        event: "HideInfoIcon",
        pageName: "connect",
        callback: () => {},
      });
    };
  }, []);

  return (
    <MainView backgroundClassName="bg-page dark:bg-black1b1f1e p-3">
      <HeaderCard
        connectService={connectService}
        isAuthorized={isAuthorized}
        isAuthLoading={isAuthLoading}
        onConnect={onConnect}
        publicPath={publicPath}
      />
      <ProductList
        connectService={connectService}
        productList={productList}
        isLoading={isLoading}
      />
      <BottomButton
        connectService={connectService}
        isAuthLoading={isAuthLoading}
        isAuthorized={isAuthorized}
        isLoading={isLoading}
        onConnect={onConnect}
        publicPath={publicPath}
      />
    </MainView>
  );
};

export { ServiceConnect };
